import { createSelector } from '@reduxjs/toolkit';

import { NOTIFICATIONS } from '@perpay-web/fintech/constants/tableNames';
import { NotificationType } from '@perpay-web/fintech/reducers/entities/notifications';
import { RootState } from '@perpay-web/fintech/store';

export const getUnacknowledgedNotifications = createSelector(
    [(state: RootState) => state.entities[NOTIFICATIONS]],
    (notifications) =>
        Object.values(notifications).filter(
            (notification) => !notification.acknowledged,
        ),
);

export const isNotificationPhoExistingUser = (state: RootState) => {
    const notifications = Object.values(state.entities[NOTIFICATIONS]);
    if (notifications.length) {
        return notifications[0].type === NotificationType.PHO_EXISTING_USER;
    }

    return false;
};
